import {WeeklyInspectionTypes} from '../ActionTypes//WeeklyInspectionTypes';

class WeeklyInspectionAction {
  static getWeeklyInspection = payload => {
    return {
      type: WeeklyInspectionTypes.GET_WEEKLY_INSPECTION_LIST,
      payload: payload,
    };
  };

  static clearWeeklyInspection = () => {
    return {
      type: WeeklyInspectionTypes.CLEAR_WEEKLY_INSPECTION_LIST,
    };
  };
}

export default WeeklyInspectionAction;
